module.exports = __webpack_public_path__ + "static/media/wmgr_kit_screen_composite.79069498.png";